import type { FC } from 'react';

import {
  GenericMultiSelect,
  type GenericMultiSelectProps,
} from '@shared/components/ui/custom/multi-select/GenericMultiSelect';
import { getDisplayLabel } from '@shared/utils/findings/trace-findings.utils';

export const FacetedMultiSelect: FC<GenericMultiSelectProps> = ({ options, ...rest }) => {
  const processedOptions = options
    .map((opt) => ({
      value: opt.value,
      label: getDisplayLabel(opt.label),
      count: opt.count,
      disabled: opt.disabled,
    }))
    .filter((opt) => opt.label !== 'empty value' && opt.value !== '')
    .sort((a, b) => {
      const countDiff = (b.count ?? 0) - (a.count ?? 0);

      if (countDiff !== 0) {
        return countDiff;
      }

      return a.label.localeCompare(b.label);
    });

  return <GenericMultiSelect options={processedOptions} {...rest} />;
};
